import React, { useEffect, useState } from 'react'
import ModalContainer from '../../../../components/modal-container/ModalContainer'
import GenericDataTable from '../../../../components/generic-datatable/GenericDataTable'
import { Column } from 'primereact/column'
import { MAIL_LOGS_TABLE_HEADERS, MAIL_LOGS_TABLE_KEYS } from './MailLogs.config'
import { ReactComponent as SendIcon } from "../../assets/Send.svg";
import { FilterMatchMode } from 'primereact/api'
import { InputText } from 'primereact/inputtext'
import { useResendMailToClientMutation } from '../../../../services/kmt/crpClient.service'
import { toast } from 'react-hot-toast'

const MailLogs = ({ visible, onHide, activeClientIndex,CRPClientsResponse }) => {
    const activeClient = CRPClientsResponse.clients[activeClientIndex]
    const [resendMail] = useResendMailToClientMutation()
    const [filters, setFilters] = useState({
        'global': { value: null, matchMode: FilterMatchMode.CONTAINS },
    });
    const [filterValue, setFilterValue] = useState('');
    const onFilterChange = (e) => {
        const value = e.target.value;
        let _filters = { ...filters };
        _filters['global'].value = value;
        setFilters(_filters);
        setFilterValue(value);
    }

    const handleResendMail = async ({ isPassword = false, projectName = '' }) => {
        const { email, firstName } = activeClient
        const payload = {
            email,
            firstName,
            isPassword,
            projectName
        }
       await toast.promise(resendMail(payload), {
        error:"The mail couldn't be sent successfully, please try again after some time",
        loading:"Sending Mail...",
        success:"Mail has been sent successfully"
       })
    }
    const displayEmailLogs = () => {
        const bodyTemplate = (data, column) => {
            if (column.field === MAIL_LOGS_TABLE_KEYS.ACTION) {
                return <div onClick={() => handleResendMail({ isPassword: data.isPassword, projectName: data.projectName })} className='cursor-pointer'><SendIcon /></div>
            }
            if (column.field === MAIL_LOGS_TABLE_KEYS.PASSWORD_OR_PROJECT_DETAILS) {
                return data.isPassword ? "Password related mail" : data.projectName
            }
        }
        const rowClassName = (data) => {
            if (data.isPassword) {
                return "password-field"
            }
        }
        return (
            <div className='DataTable'>
                <div className="flex justify-content-end mb-4">
                    <span className="p-input-icon-left">
                        <i className="pi pi-search" />
                        <InputText value={filterValue} onChange={onFilterChange} placeholder="Search" />
                    </span>
                </div>
                <GenericDataTable rowClassName={rowClassName} filters={filters} paginator rows={5} tableClassName='white-space-nowrap font-medium' value={activeClient?.emailLogs} spacedRows={true} sortMode="multiple" responsiveLayout="scroll">
                    <Column align="center" body={bodyTemplate} field={MAIL_LOGS_TABLE_KEYS.PASSWORD_OR_PROJECT_DETAILS} header={MAIL_LOGS_TABLE_HEADERS[MAIL_LOGS_TABLE_KEYS.PASSWORD_OR_PROJECT_DETAILS]} />
                    <Column align="center" body={bodyTemplate} field={MAIL_LOGS_TABLE_KEYS.ACTION} header={MAIL_LOGS_TABLE_HEADERS[MAIL_LOGS_TABLE_KEYS.ACTION]} />
                </GenericDataTable>
            </div>
        )

    }

    return (
        <ModalContainer visible={visible} onHide={onHide} draggable={false} headerClassName="text-white" header="Email Logs" style={{ width: "75%" }}>
            {activeClient?.emailLogs?.length === 0 ? "No logs were found for this client" : displayEmailLogs()}
        </ModalContainer>
    )
}

export default MailLogs